import { useTitle } from 'react-use'

const APP_NAME = 'Clinically AI - Comply'

const usePageTitle = (page: string) => {
  useTitle(`${APP_NAME} - ${page}`)
}

export default usePageTitle
